import React from 'react';
import { GlassGradient, GlassPanel, Handle, BattenteTriangleFill, AntaRibaltaFill, VasistasFill, FixedMark, SlidingArrow, BilicoH, BilicoV } from './primitives';

export const singleSash = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_ss" />
    <GlassPanel x={10} y={8} w={60} h={84} gradId="g_ss" />
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <Handle x={62} y={50} />
  </svg>
);

export const doubleSash = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_ds" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_ds" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_ds" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <Handle x={46} y={50} />
  </svg>
);

export const tripleSash = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_ts" />
    <GlassPanel x={10} y={8} w={30} h={84} gradId="g_ts" />
    <GlassPanel x={44} y={8} w={32} h={84} gradId="g_ts" />
    <GlassPanel x={80} y={8} w={30} h={84} gradId="g_ts" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const singleWithTopLight = () => (
  <svg viewBox="0 0 80 110" className="w-full h-full">
    <GlassGradient id="g_stl" />
    <GlassPanel x={10} y={8} w={60} h={22} gradId="g_stl" />
    <GlassPanel x={10} y={34} w={60} h={68} gradId="g_stl" />
    <rect x={4} y={4} width={72} height={102} fill="none" stroke="#222" strokeWidth="2.5" />
    <Handle x={62} y={68} />
  </svg>
);

export const singleWithBottomLight = () => (
  <svg viewBox="0 0 80 110" className="w-full h-full">
    <GlassGradient id="g_sbl" />
    <GlassPanel x={10} y={8} w={60} h={68} gradId="g_sbl" />
    <GlassPanel x={10} y={80} w={60} h={22} gradId="g_sbl" />
    <rect x={4} y={4} width={72} height={102} fill="none" stroke="#222" strokeWidth="2.5" />
    <Handle x={62} y={42} />
  </svg>
);

export const doubleWithTopLight = () => (
  <svg viewBox="0 0 100 110" className="w-full h-full">
    <GlassGradient id="g_dtl" />
    <GlassPanel x={10} y={8} w={80} h={22} gradId="g_dtl" />
    <GlassPanel x={10} y={34} w={38} h={68} gradId="g_dtl" />
    <GlassPanel x={52} y={34} w={38} h={68} gradId="g_dtl" />
    <rect x={4} y={4} width={92} height={102} fill="none" stroke="#222" strokeWidth="2.5" />
    <Handle x={46} y={68} />
  </svg>
);

export const tripleWithTopLight = () => (
  <svg viewBox="0 0 120 110" className="w-full h-full">
    <GlassGradient id="g_ttl" />
    <GlassPanel x={10} y={8} w={100} h={22} gradId="g_ttl" />
    <GlassPanel x={10} y={34} w={30} h={68} gradId="g_ttl" />
    <GlassPanel x={44} y={34} w={32} h={68} gradId="g_ttl" />
    <GlassPanel x={80} y={34} w={30} h={68} gradId="g_ttl" />
    <rect x={4} y={4} width={112} height={102} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const quadWithTopLight = () => (
  <svg viewBox="0 0 140 110" className="w-full h-full">
    <GlassGradient id="g_qtl" />
    <GlassPanel x={10} y={8} w={120} h={22} gradId="g_qtl" />
    <GlassPanel x={10} y={34} w={27} h={68} gradId="g_qtl" />
    <GlassPanel x={41} y={34} w={27} h={68} gradId="g_qtl" />
    <GlassPanel x={72} y={34} w={27} h={68} gradId="g_qtl" />
    <GlassPanel x={103} y={34} w={27} h={68} gradId="g_qtl" />
    <rect x={4} y={4} width={132} height={102} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const fixedWindow = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_fw" />
    <GlassPanel x={10} y={8} w={60} h={84} gradId="g_fw" />
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={10} y={8} w={60} h={84} />
  </svg>
);

export const quadrantWindow = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_qw" />
    <defs><clipPath id="clip_qw"><path d="M10,92 L10,30 Q10,8 40,8 Q70,8 70,30 L70,92 Z" /></clipPath></defs>
    <rect x={10} y={8} width={60} height={84} fill="#BDD2ED" clipPath="url(#clip_qw)" />
    <rect x={10} y={8} width={60} height={84} fill="url(#g_qw)" clipPath="url(#clip_qw)" />
    <path d="M10,92 L10,30 Q10,8 40,8 Q70,8 70,30 L70,92 Z" fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const arch2Window = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_a2w" />
    <defs><clipPath id="clip_a2w"><path d="M10,92 L10,30 Q10,8 50,8 Q90,8 90,30 L90,92 Z" /></clipPath></defs>
    <rect x={10} y={8} width={80} height={84} fill="#BDD2ED" clipPath="url(#clip_a2w)" />
    <rect x={10} y={8} width={80} height={84} fill="url(#g_a2w)" clipPath="url(#clip_a2w)" />
    <path d="M10,92 L10,30 Q10,8 50,8 Q90,8 90,30 L90,92 Z" fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={50} y1={8} x2={50} y2={92} stroke="#333" strokeWidth="1" />
  </svg>
);

export const triangleWindow = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_tw" />
    <polygon points="40,8 72,92 8,92" fill="#BDD2ED" />
    <polygon points="40,8 72,92 8,92" fill="url(#g_tw)" />
    <polygon points="40,8 72,92 8,92" fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const trapezoidWindow = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_trw" />
    <polygon points="20,8 60,8 72,92 8,92" fill="#BDD2ED" />
    <polygon points="20,8 60,8 72,92 8,92" fill="url(#g_trw)" />
    <polygon points="20,8 60,8 72,92 8,92" fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const circleWindow = () => (
  <svg viewBox="0 0 80 80" className="w-full h-full">
    <GlassGradient id="g_cw" />
    <circle cx={40} cy={40} r={34} fill="#BDD2ED" />
    <circle cx={40} cy={40} r={34} fill="url(#g_cw)" />
    <circle cx={40} cy={40} r={34} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const atypicalShape = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_as" />
    <defs><clipPath id="clip_as"><path d="M10,92 L10,30 Q10,8 40,8 Q70,8 70,30 L70,92 Z" /></clipPath></defs>
    <rect x={10} y={8} width={60} height={84} fill="#BDD2ED" clipPath="url(#clip_as)" />
    <path d="M10,92 L10,30 Q10,8 40,8 Q70,8 70,30 L70,92 Z" fill="none" stroke="#222" strokeWidth="2.5" />
    <circle cx={40} cy={30} r={8} fill="none" stroke="#555" strokeWidth="1" strokeDasharray="3,2" />
    <polygon points="30,65 50,65 40,50" fill="none" stroke="#555" strokeWidth="1" strokeDasharray="3,2" />
  </svg>
);

export const tiltTurn = () => (
  <svg viewBox="0 0 60 120" className="w-full h-full">
    <GlassGradient id="g_tt" />
    <GlassPanel x={8} y={6} w={44} h={108} gradId="g_tt" />
    <rect x={4} y={4} width={52} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={8} y={6} w={44} h={108} side="right" />
  </svg>
);

